import React from 'react';
import { Accordion } from 'react-bootstrap';

import { Comunicacao } from '../../modules/types/Comunicacao';
import ComunicacaoItem from '../Comunicacao';

type Props = {
  comunicacoes: Comunicacao[];
};

const BoxComunicacoes: React.FC<Props> = ({ comunicacoes }) => {
  return (
    <Accordion defaultActiveKey={String(comunicacoes[0]?.id)} alwaysOpen>
      {comunicacoes.map((item) => (
        <ComunicacaoItem key={item.id} comunicacao={item} />
      ))}
    </Accordion>
  );
};

export default BoxComunicacoes;
